import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router'
import { withTranslation } from 'react-i18next'
import { withRouter, } from 'react-router-dom'
import { DigitalVaultUploadView } from '../../views'
import { CategoryService, CompanyService, LocalStorageService, DigitalVaultDocumentService, ClientService, TemplateService } from '../../../services'
import DocumentsType from '../../../services/documents-type.service'
import { getFileMediaType, setCreditsToDocuments } from '../../../utils'
import { PDFDocument } from 'pdf-lib'
import { convertToStandarDate } from '../../../utils'
import { BusinessAdministrationValidator } from '../../../validators'

const DigitalVaultUploadAction = (props) => {

    let {
        documentId,
        documentData,
        handleSaveData,
        noWorkflow,
        handleSubmitNoWorkflow,
        t
    } = props

    const history = useHistory()
    const { search, state } = useLocation()

    const url = process.env.REACT_APP_MIFIRMA_API
    const localStorageService = new LocalStorageService()
    const companyService = new CompanyService(url)
    const categoryService = new CategoryService(url)
    const digitalVaultDocumentService = new DigitalVaultDocumentService(url)
    const preferenceService = new ClientService(url)
    const templateService = new TemplateService(url)
    const documentsTypeService = new DocumentsType(url)
    const ENV = process.env

    const token = localStorageService.getLocalStorageItem('token').idToken
    const timezone = localStorageService.getLocalStorageItem('timezone')
    const user = localStorageService.getLocalStorageItem('user')


    const [firstLoad, setFirstLoad] = useState(true)
    const [isLoading, setIsLoading] = useState(false)
    const [showLoadingRequesting, setShowLoadingRequesting] = useState(false)
    const [showErrorRequesting, setShowErrorRequesting] = useState(false)
    const [showCompletedRequesting, setShowCompletedRequesting] = useState(false)
    const [messageError, setMessageError] = useState('')
    const [invalidFields, setInvalidFields] = useState([])
    const [fileType, setFileType] = useState('pdf')
    const [fileManagerState, setFileManagerState] = useState({})

    // Categorias y subcategorias
    const language = localStorageService.getLocalStorageItem('preferredLanguage') || 'es'
    const [showCategoryWarningModal, setShowCategoryWarningModal] = useState(false)
    const [categoryWarningMessage, setCategoryWarningMessage] = useState('')
    const [strBtn, setStrBtn] = useState(t('fileManager.toolbar.newCategory'))
    const [pendingSubcategoryId, setPendingSubcategoryId] = useState(null)
    const [showAddFileBtn, setShowAddFileBtn] = useState(false)
    const [categoriesData, setCategoriesData] = useState([])
    const [documentsData, setDocumentsData] = useState([])
    const [categoryName, setCategoryName] = useState('')
    const [permission, setPermission] = useState({})
    const [parentId, setParentId] = useState(null)
    const [fileData, setFileData] = useState([])
    const [level, setLevel] = useState(1)

    // creacion de una categoria o subcategoria
    const [showCategoryInputDialog, setShowCategoryInputDialog] = useState(false)
    const [showCategoryDialog, setShowCategoryDialog] = useState(false)
    const [categoryNameError, setCategoryNameError] = useState(false)
    const [selectedVariables, setSelectedVariables] = useState([])
    const [modeCategory, setModeCategory] = useState('category')
    const [messageDialog, setMessageDialog] = useState('')
    const validator = BusinessAdministrationValidator(t)
    const [companyId, setCompanyId] = useState(null)

    //Checboxes
    const [confidential, setConfidential] = useState(false)
    const [mandatory, setMandatory] = useState(false)
    const [notify, setNotify] = useState(false)

    //Tags
    const [inputTag, setInputTag] = useState('')
    const [tags, setTags] = useState([])

    //Fecha
    const [isDateEndManuallySet, setIsDateEndManuallySet] = useState(false)
    const [formatCeleb, setFormatCeleb] = useState('dd/MM/yyyy')
    const [formatVen, setFormatVen] = useState('dd/MM/yyyy')
    const [dateStart, setDateStart] = useState(new Date())
    const [limitDateDue, setLimitDateDue] = useState(new Date())
    const [dateEnd, setDateEnd] = useState(null)

    // Variables
    const [customVariables, setCustomVariables] = useState([])
    const [valueVariable, setValueVariable] = useState('')
    const [variableName, setVariableName] = useState('')
    const [showModal, setShowModal] = useState(false)
    const [typeData, setTypeData] = useState(null)

    // Entidades
    const [showEntitiesSuccessModal, setShowEntitiesSuccessModal] = useState(false)
    const [entitiesExtracted, setEntitiesExtracted] = useState(false)

    // Formatos de variables (para modal idéntico al panel de variables)
    const [formatVariables, setFormatVariables] = useState([])

    const infoTypes = [
        { id: 1, name: t('digitalVaultUploadView.type.document') },
        { id: 2, name: t('digitalVaultUploadView.type.exp') }
    ]
    const [companies, setCompanies] = useState([{ id: 0, companyName: t('digitalVaultUploadView.unassigned') }])
    const [categories, setCategories] = useState([{ id: 0, name: t('digitalVaultUploadView.unassigned') }])
    const [subcategoryTree, setSubcategoryTree] = useState([])
    const [typeDocuments, setTypeDocuments] = useState([])
    const [allTypeDocuments, setAllTypeDocuments] = useState([])
    const [showUploadBtn, setShowUploadBtn] = useState(true)
    const [urlPdf, setUrlPdf] = useState(url)
    const [blobAWS, setBlobAWS] = useState(url)
    const [showBtnCancel, setShowBtnCancel] = useState(false)
    const [uploadData, setUploadData] = useState({
        infoType: 1,
        name: '',
        companyId: null,
        categoryId: null,
        pathBreadcrumb: [],
        typeDocument: null,
        uploadedFiles: [],
        description: '',
        tags: [],
        variables: [],
        confidential: false,
        notify: false,
        mandatory: false
    })
    const [showDialogSendDocToOcr, setShowDialogSendDocToOcr] = useState(false)
    const [documentsToOCR, setDocumentsToOCR] = useState([])
    const [totalCredits, setTotalCredits] = useState(0)


    useEffect(() => {
        if (!documentData) return
        const confidentialBD = documentData.confidential === 'true'
        const mandatoryBD = documentData.mandatory === 'true'
        const notifyBD = documentData.notify === 'true'
        const startDateFromBD = documentData.startDate ? new Date(documentData.startDate) : null
        const validationDateFromBD = documentData.validation ? new Date(documentData.validation) : null

        if (startDateFromBD) {
            setDateStart(startDateFromBD)

            const limit = new Date(startDateFromBD)
            limit.setDate(limit.getDate() + 1)
            setLimitDateDue(limit)
        }

        if (validationDateFromBD) {
            setDateEnd(validationDateFromBD)
        }

        setConfidential(confidentialBD)
        setNotify(notifyBD)
        setMandatory(mandatoryBD)
    }, [documentData])



    //* SELECCIONAR UNA CATEGORIA Y SUBCATEGORIA
    const handleTreeNodeClick = (e) => {
        let selectedNode = e?.nodeData || null

        if (!selectedNode && Array.isArray(e?.data) && e.data.length > 0) {
            selectedNode = e.data[0]
        }

        if (!selectedNode) return

        handleUploadDataChange('pathBreadcrumb', [selectedNode.id])
        handleUploadDataChange('categoryId', selectedNode.id)
    };

    async function createNewCategory({
        categoryName,
        companyId,
        createAllCompanies,
        level,
        parent,
        type
    }) {
        toggleLoadingRequesting(true)

        try {
            const finalCompanyId = companyId ?? uploadData.companyId
            if (!finalCompanyId || finalCompanyId === 0) {
                toggleLoadingRequesting(false)
                return
            }

            const response = await categoryService.createNewCategory(
                categoryName,
                null,
                null,
                null,
                'Custom',
                finalCompanyId,
                type,
                level,
                parent,
                createAllCompanies,
                token
            );

            if (response.data && response.statusCode === 200) {
                // Actualiza estados
                await refreshFileManager(true)

                toggleCompletedRequesting(
                    `${type === ENV.REACT_APP_CATEGORIES_TYPE_SUB ? t('digitalVaultUploadView.subcategory') : t('digitalVaultUploadView.catgory')} ${t('digitalVaultUploadView.created')}: ${response.data.name}`,
                    true
                )
            } else {
                const typeLabel = (type === ENV.REACT_APP_CATEGORIES_TYPE_SUB) ? t('digitalVaultUploadView.subcategory') : t('digitalVaultUploadView.catgory')
                let messageError = (response && response.message) ? response.message : t('digitalVaultUploadView.errors.new.category', { type: typeLabel })
                if (response && response.statusCode === 403) messageError = t('digitalVaultUploadView.errors.new.category.permission', { type: typeLabel })
                if (response && response.statusCode === 420) messageError = t('digitalVaultUploadView.errors.new.category.repeat')
                toggleErrorRequesting(true, messageError, 4000, false)
            }
        } catch (error) {
            const typeLabel = (type === ENV.REACT_APP_CATEGORIES_TYPE_SUB) ? t('digitalVaultUploadView.subcategory') : t('digitalVaultUploadView.catgory')
            let messageError = (error && error.message) ? error.message : t('digitalVaultUploadView.errors.new.category', { type: typeLabel })
            if (error && error.statusCode === 403) messageError = t('digitalVaultUploadView.errors.new.category.permission', { type: typeLabel })
            if (error && error.statusCode === 420) messageError = t('digitalVaultUploadView.errors.new.category.repeat')
            toggleErrorRequesting(true, messageError, 4000, false)
        } finally {
            toggleLoadingRequesting(false)
        }
    }


    const handleCreateCategoryOrSubcategory = () => {
        createNewCategory({
            categoryName: categoryName.trim(),
            companyId,
            createAllCompanies: false,
            level,
            parent: modeCategory === 'subcategory' ? parentId : null,
            type: modeCategory === 'category' ? 'Cat' : 'Sub'
        })

        setShowCategoryInputDialog(false)
        setCategoryName('')
    }


    function handleCreateNewCategory({ allCompanies }) {
        createNewCategory({
            categoryName: categoryName,
            companyId,
            createAllCompanies: allCompanies,
            level,
            parent: modeCategory === 'subcategory' ? parentId : null,
            type: modeCategory === 'category' ? 'Cat' : 'Sub'
        })

        setShowCategoryDialog(false)
        setCategoryName('')
    }


    // Valida el input del nombre usando el validador del negocio
    function validateNameInput(name) {
        const validationError = validator.businessNameValidator(name)
        return validationError === ''
    }


    const openCategories = () => {
        if (!uploadData.companyId || uploadData.companyId === 0) {
            toggleErrorRequesting(true, t('digitalVaultUploadView.modal.category.error.noCompany'), 3000, false)
            return
        }

        setModeCategory('category')
        setParentId(null)
        setLevel(1)
        setStrBtn(t('fileManager.toolbar.newCategory'))
        setCategoryName('')
        setShowCategoryInputDialog(true)
    }

    const openSubcategories = () => {
        if (!uploadData.companyId || uploadData.companyId === 0) {
            toggleErrorRequesting(true, t('digitalVaultUploadView.modal.subcategory.error.noCompany'), 3000, false)
            return
        }

        if (!uploadData.categoryId) {
            toggleErrorRequesting(true, t('digitalVaultUploadView.modal.subcategory.error.noCategory'), 3000, false)
            return
        }

        setModeCategory('subcategory')
        setParentId(uploadData.categoryId)
        setLevel((uploadData.pathBreadcrumb?.length || 0) + 1)
        setStrBtn(t('fileManager.toolbar.newSubcategory'))
        setCategoryName('')
        setShowCategoryInputDialog(true)
    }

    function handleSubmitCategoryOrSubcategory() {

        if (!validateNameInput(categoryName)) {
            setCategoryNameError(true)
            return
        }
        setCategoryNameError(false)
        setShowCategoryInputDialog(false)
        setShowCategoryDialog(true)
    }

    //* ----------------------

    //* CREAT TAG
    const onBlurInputTag = () => {
        if (!inputTag || inputTag.trim() === '' || inputTag.length > 50) return
        const tagExist = tags.some(tag => (typeof tag === 'string' ? tag : (tag?.text || '')) === inputTag.trim())
        if (tagExist) {
            setInputTag('')
            return
        }

        let copyTags = [...tags]
        let newTag = {
            text: (inputTag) ? inputTag : null,
            value: copyTags.length + 1,
            action: 1
        }

        if (newTag && newTag.text) {
            copyTags.push(newTag)
            setTags(copyTags)
            setInputTag('')

            setUploadData(prev => ({
                ...prev,
                tags: copyTags.map(tag => tag.text)
            }))
        }
    }

    const handleDeleteChipTag = (e) => {
        let copyTags = [...tags]
        let tagDelete = e.target.props.dataItem
        let tagsFilter = copyTags.filter((tag) => tag.value !== tagDelete.value)
        setTags(tagsFilter)

        setUploadData(prev => ({
            ...prev,
            tags: tagsFilter.map(tag => tag.text)
        }))
    }

    const handleInputTag = (e) => {
        let value = e.target.value
        setInputTag(value)
    }

    //* ----------------------

    //* CHECKBOX CONFIDENCIAL O NOTIFICACION DE VENCIMIENTO
    const handleChangeCheckConfidential = (e) => {
        const value = e.target.checked
        setConfidential(value)

        setUploadData(prev => ({
            ...prev,
            confidential: value
        }))
    }

    const handleChangeCheckNotify = (e) => {
        const value = e.target.checked
        setNotify(value)
        setUploadData(prev => ({
            ...prev,
            notify: value
        }))
    }

    //* ----------------------

    //* Crear una variable

    const clearInputs = () => {
        setVariableName('')
        setTypeData(null)
        setValueVariable('')
    }

    const deleteVariable = (dataItem) => {
        setCustomVariables(prev =>
            prev.map(v => v.id === dataItem.id ? { ...v, deleted: true } : v)
        )
    }

    const handleSaveVariable = () => {

        if (!variableName || typeData === null || typeData === undefined || !valueVariable) {
            console.warn('Faltan datos para guardar:', { variableName, typeData, valueVariable })
            return
        }

        const newVariable = {
            variableName,
            typeData: mapTypeData(typeData),
            valueVariable
        }

        setCustomVariables(prev => [...prev, newVariable])
        clearInputs()
        setShowModal(false)
    }

    const mapTypeData = (id) => {
        switch (id) {
            case 0: return 'text'
            case 1: return 'amount'
            case 2: return 'date'
            case 3: return 'boolean'
            case 4: return 'multi-select'
            default: return 'text'
        }
    }

    const openModalVariable = () => setShowModal(true)
    const closeModalVariable = () => setShowModal(false)

    //* ----------------------

    //* CREAT LA FECHA

    const onChangeDatepicker = (e) => {
        const valueStr = e.target.value
        setDateStart(valueStr)

        if (valueStr) {
            const valueDate = new Date(valueStr)
            const limitDate = new Date(valueDate)
            limitDate.setDate(limitDate.getDate() + 1)
            setLimitDateDue(limitDate)
        } else {
            setLimitDateDue('')
        }
    }

    const onChangeDatepickerDateEnd = (e) => {
        const selectedDateStr = e.target.value

        if (!selectedDateStr) {
            setDateEnd(null)
            setIsDateEndManuallySet(false)
            return
        }

        const selectedDate = new Date(selectedDateStr)

        if (!isNaN(selectedDate)) {
            setDateEnd(selectedDate)
            setIsDateEndManuallySet(true)
        }
    }

    //* ----------------------


    //* EXTRAER UNA ENTIDAD
    const openModalExtractEntities = async () => {
        if (documentId) {
            try {
                toggleLoadingRequesting(true)
                const document = await digitalVaultDocumentService.getDocumentPages(documentId, token)
                if (document && document.data && Number(document.statusCode) === 200) {
                    const docsCreditsOCR = setCreditsToDocuments(document.data.files, t)
                    setDocumentsToOCR(docsCreditsOCR.documentsToOCR)
                    setTotalCredits(docsCreditsOCR.totalCredits)
                    setShowDialogSendDocToOcr(true)
                }
                toggleLoadingRequesting(false)
            } catch (err) {
                toggleLoadingRequesting(false)
                toggleErrorRequesting(true, t('digitalVaultUploadView.modal.entities.errorEntities'), 3000, false)
            }
        } else {
            if (!uploadData?.uploadedFiles?.length) {
                toggleErrorRequesting(true, t('digitalVaultUploadView.modal.entities.extract'), 3000, false)
                return
            }

            if (uploadData?.uploadedFiles?.length === 1 && uploadData.uploadedFiles[0].type !== 'application/pdf') {
                toggleErrorRequesting(true, t('digitalVaultUploadView.modal.entities.onlyPdf'), 3000, false)
                return
            }

            try {
                const pdfFiles = uploadData.uploadedFiles.filter(file => file.type === 'application/pdf')
                const processedFiles = []
                for (const file of pdfFiles) {
                    const arrayBuffer = await file.file.arrayBuffer()
                    const pdfDoc = await PDFDocument.load(arrayBuffer)
                    const pages = pdfDoc.getPages()
                    processedFiles.push({
                        ...file,
                        id: file.id || Date.now(),
                        pages: pages.length || 0
                    })
                }

                const docsCreditsOCR = setCreditsToDocuments(processedFiles, t)
                setDocumentsToOCR(docsCreditsOCR.documentsToOCR)
                setTotalCredits(docsCreditsOCR.totalCredits)
                setShowDialogSendDocToOcr(true)
            } catch (err) {
                toggleErrorRequesting(true, t('digitalVaultUploadView.modal.entities.errorPreparingDocs'), 3000, false)
            }
        }
    }

    //* ----------------------

    function toggleLoadingRequesting(value) {
        setShowLoadingRequesting(value)
    }

    async function fetchAndSetCategories({
        refresh = false,
        setLoading = false,
        companyId,
        createdCategoryName
    }) {
        if (setLoading) setIsLoading(true)
        try {
            const response = await categoryService.getAllCategoriesByCompanyId(
                {
                    companyId,
                    timezone: timezone,
                    token: token,
                },
                refresh
            )

            let categories
            if (response && response.data && Number(response.statusCode) === 200) {
                categories = response.data.fileData
                setPermission(response.data.permission)
                setCategoriesData(categories)
            }

            const data = categories.map((cat) => ({
                dateCreated: convertToStandarDate(cat.dateCreated, language),
                dateModified: convertToStandarDate(cat.dateModified, language),
                filterPath: cat.filterPath,
                hasChild: cat.hasChild,
                id: cat.id,
                isFile: cat.isFile,
                name: cat.name,
                parentId: cat.parentId,
                size: cat.size,
                type: cat.type,
                imageUrl: cat.imageUrl
            }))

            setFileData(data)
            const exists = data.some(cat => cat.name === createdCategoryName)
            return { categories, data }
        } catch (error) {
        } finally {
            if (setLoading) setIsLoading(false)
        }
    }


    async function refreshFileManager(refresh = true) {
        try {
            await fetchAndSetCategories({
                refresh,
                setLoading: false,
                companyId: uploadData.companyId
            })
        } catch (err) {
            console.error('Error', err)
        }
    }


    function toggleCompletedRequesting(message, refresh) {
        setShowCompletedRequesting(true)
        setMessageDialog(message)

        setTimeout(() => {
            setShowCompletedRequesting(false)
            setMessageDialog('')
        }, 4000)

        refreshFileManager(refresh)
    }


    //* -------------------

    const toggleErrorRequesting = (value, message, time, sendInbox) => {
        setShowErrorRequesting(value)
        setMessageError(message)

        if (value) {
            setTimeout(() => {
                setShowErrorRequesting(false)
                setMessageError('')
                if (sendInbox) {
                    history.push('/')
                }
            }, time)
        }
    }

    const pdfToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => resolve(reader.result)
            reader.onerror = (error) => reject(error)
        }
        )


    const handleFiles = async (e, onError) => {
        const formatBytes = (bytes, decimals = 2) => {
            if (bytes === 0) return '0 Bytes'
            const k = 1024
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
            const i = Math.floor(Math.log(bytes) / Math.log(k))
            return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + ' ' + sizes[i]
        }

        const MAX_FILE_SIZE_MB = 80
        const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024

        let newFiles = []

        for (let i = 0; i < e.target.files.length; i++) {
            const currentFile = e.target.files[i]

            if (currentFile.size > MAX_FILE_SIZE_BYTES) {
                const formattedSize = formatBytes(currentFile.size)
                const formattedLimit = formatBytes(MAX_FILE_SIZE_BYTES)

                if (onError) {
                    onError(
                        `${t('loadFields.max.file.size')} '${currentFile.name}' ${t('loadFields.exceed.max.file.size')} ${formattedSize} ${t('loadFields.exceed.max.file.size.limit')} ${formattedLimit}.`
                    )
                }
                return
            }

            const fileBase64 = await pdfToBase64(currentFile)
            const pdfBase64 = fileBase64.split(',')[1]
            const fileType = getFileMediaType(currentFile, 'type')

            newFiles.push({
                name: currentFile.name,
                file: currentFile,
                fileBase64: pdfBase64,
                type: currentFile.type,
                fileType
            })
        }

        setInvalidFields((prev) => prev.filter((i) => i !== 'files'))

        setUploadData((prev) => {
            let files = []
            if (prev.infoType === 1) {
                files = [newFiles[0]]
            } else {
                files = [...prev.uploadedFiles]
                for (let i = 0; i < newFiles.length; i++) {
                    if (!files.find((f) => f.name === newFiles[i].name)) {
                        files.push(newFiles[i])
                    }
                }
            }

            return {
                ...prev,
                uploadedFiles: files,
            }
        })

        setFileType(newFiles[0].fileType)
    }


    //! AQUI SE CARGA EL NUEVO COMPONENTE DE CATEGORIAS
    const deleteFile = (file) => {
        setUploadData(prev => {
            const updatedFiles = prev.uploadedFiles.filter(f => f.name != file.name && f.fileBase64 != file.fileBase64)
            return {
                ...prev,
                uploadedFiles: updatedFiles
            }
        })
    }

    const loadCompanies = async () => {
        setIsLoading(true)

        try {
            const response = await companyService.getUsersCompanies(token)
            if (response.statusCode == 200 && response.data) {
                let companiesData = response.data

                const userRoles = user && user.userMetaData && user.userMetaData.userRoles ? user.userMetaData.userRoles : []
                const isSuperAdmin = userRoles.some(r => r && r.role && r.role.key === process.env.REACT_APP_ADMIN)
                const isVaultAdmin = userRoles.some(r => r && r.role && r.role.key === process.env.REACT_APP_ADMIN_DIGITAL_VAULT)

                if (isSuperAdmin || isVaultAdmin) {
                    companiesData = response.data.filter(item => {
                        const isExclusive = item.isExclusive || (item.company && item.company.isExclusive)
                        return !isExclusive
                    })
                }

                let companyOptions = companiesData.map(el => el.company)
                companyOptions.sort((a, b) => a.companyName.toLowerCase().localeCompare(b.companyName.toLowerCase()))
                companyOptions = [{ id: 0, companyName: t('digitalVaultUploadView.unassigned') }, ...companyOptions]
                setCompanies(companyOptions)

                const params = new URLSearchParams(search)
                const companyIdParam = params.get('companyId')
                if (params.size === 0 || params.size === 1) setFirstLoad(false)
                handleUploadDataChange('companyId', companyIdParam || companyOptions[0].id)
            } else {
                throw new Error(response.message || t('digitalVaultUploadView.errors.general.load.companies'))
            }
            setIsLoading(false)
        } catch (e) {
            toggleErrorRequesting(true, e.message, 4000, true)
        }
    }

    const loadCategories = async (companyId = uploadData.companyId) => {
        setShowLoadingRequesting(true)

        try {
            const response = await categoryService.getAllCategoriesByCompanyId({ companyId, token })

            let categories
            if (response && response.data && Number(response.statusCode) === 200) {
                categories = response.data.fileData
                setPermission(response.data.permission)
                setCategoriesData(categories)
            }

            const data = categories.map((cat) => ({
                dateCreated: convertToStandarDate(cat.dateCreated, language),
                dateModified: convertToStandarDate(cat.dateModified, language),
                filterPath: cat.filterPath,
                hasChild: cat.hasChild,
                id: Number(cat.id),
                isFile: cat.isFile,
                name: cat.name,
                parentId: cat.parentId !== null ? Number(cat.parentId) : null,
                size: cat.size,
                type: cat.type,
                imageUrl: cat.imageUrl
            }))

            setIsLoading(false)
            setFileData(data)
            return { categories, data }
        } catch (error) {
            console.error('Error', error)
        } finally {
            setShowLoadingRequesting(false)
        }
    }

    const loadSubcategories = async (subcategoryPath) => {
        try {
            const response = await categoryService.getDocumentsBySubcategory(
                subcategoryPath,
                uploadData.companyId,
                null,
                null,
                token
            )

            if (response && response.data && Number(response.statusCode) === 200) {
                response.data.forEach(doc => {
                })
                setDocumentsData(response.data)
            }
        } catch (error) {
            console.error('Error', error)
        }
    }

    const handleUploadDataChange = async (field, value) => {
        if (field === 'companyId') {
            try {
                setCategoriesData([])
                setSubcategoryTree([])
                setDocumentsData([])
            } catch (_) { }

            setUploadData(prev => ({
                ...prev,
                uploadedFiles: prev.uploadedFiles,
                companyId: value,
                categoryId: null,
                pathBreadcrumb: [],
            }))

            setCategories([{ id: 0, name: t('digitalVaultUploadView.unassigned') }])

            setInvalidFields(prev => prev.filter(k => !['categoryId', 'pathBreadcrumb'].includes(k)))
            return
        }

        setUploadData(prev => ({
            ...prev,
            uploadedFiles: field === 'infoType' ? [] : prev.uploadedFiles,
            [field]: value
        }))
    }

    useEffect(() => {
        if (uploadData.companyId != null) {
            if (uploadData.companyId == 0) setCategories([{ id: 0, name: t('digitalVaultUploadView.unassigned') }])
            else loadCategories(uploadData.companyId)
        }
    }, [uploadData.companyId])

    useEffect(() => {
        if (uploadData.categoryId != null) {
            if (uploadData.categoryId === 0) {
                setSubcategoryTree([])
            } else {
                loadSubcategories(uploadData.categoryId)
            }
        }
    }, [uploadData.categoryId])

    useEffect(() => {
        if (!firstLoad && !documentId) {
            history.replace({ pathname: `/digital-vault-upload` })
        }
    }, [firstLoad])

    useEffect(() => {
        setFileManagerState(state)
    }, [])

    const onCancel = () => {
        history.push({
            pathname: `/digital-vault/home`,
            state: fileManagerState
        })
    }

    const validateData = () => {
        let invalidFields = []
        if (uploadData.name.trim() === '') {
            invalidFields.push('name')
        }
        if (uploadData.categoryId === 0) {
            invalidFields.push('categoryId')
        }
        if (!uploadData.typeDocument || uploadData.typeDocument.name.trim() === '') {
            invalidFields.push('typeDocument')
        }
        if (!uploadData.pathBreadcrumb || uploadData.pathBreadcrumb.length === 0) {
            invalidFields.push('pathBreadcrumb')
        }
        if (uploadData.uploadedFiles.length === 0) {
            invalidFields.push('files')
        }
        setInvalidFields(invalidFields)
        return invalidFields.length === 0
    }

    const validateUpdateData = () => {
        let invalidFields = []
        if (uploadData.name.trim() === '') {
            invalidFields.push('name')
        }
        if (uploadData.categoryId === 0) {
            invalidFields.push('categoryId')
        }
        if (!uploadData.typeDocument || uploadData.typeDocument.name.trim() === '') {
            invalidFields.push('typeDocument')
        }
        if (!uploadData.pathBreadcrumb || uploadData.pathBreadcrumb.length === 0) {
            invalidFields.push('pathBreadcrumb')
        }
        setInvalidFields(invalidFields)
        return invalidFields.length === 0
    }

    const isSubcategorySelected = () => {
        const id = uploadData.categoryId
        if (!id) return false
        const byFileData = Array.isArray(fileData) ? fileData.find(n => Number(n.id) === Number(id)) : null
        const byCategories = Array.isArray(categoriesData) ? categoriesData.find(n => Number(n.id) === Number(id)) : null
        const node = byFileData || byCategories

        if (node) {
            const hasParentIdField = Object.prototype.hasOwnProperty.call(node, 'parentId')
            const parentId = hasParentIdField ? node.parentId : null
            const hasParent = typeof parentId === 'number' ? parentId > 0 : (parentId !== null && parentId !== undefined && parentId !== '0')
            const isLevelSub = typeof node.level === 'number' ? node.level > 1 : false
            const isTypeSub = typeof node.type === 'string' ? node.type.toLowerCase().includes('sub') : false
            if (hasParent || isLevelSub || isTypeSub) return true
        }

        return Array.isArray(uploadData.pathBreadcrumb) && uploadData.pathBreadcrumb.length > 1
    }

    const onSave = async (searcPreference, ocrSelected, overrideCategoryId = null) => {
        const isSpanish = (language || 'es').toLowerCase().startsWith('es')
        const noun = Number(uploadData.infoType) === 2
            ? t('digitalVaultUpload.noun.file', { defaultValue: isSpanish ? 'expediente' : 'file' })
            : t('digitalVaultUpload.noun.document', { defaultValue: isSpanish ? 'documento' : 'document' })

        if (!uploadData.companyId || Number(uploadData.companyId) === 0) {
            const msgPrefix = t('digitalVaultUpload.error.select.company', {
                defaultValue: isSpanish
                    ? 'Debes de seleccionar una empresa antes de cargar un'
                    : 'You must select a company before uploading a'
            })
            setCategoryWarningMessage(`${msgPrefix} ${noun}.`)
            setShowCategoryWarningModal(true)
            return
        }

        const hasValidSubcategory = isSubcategorySelected()
        if (!hasValidSubcategory) {
            setCategoryWarningMessage('')
            setShowCategoryWarningModal(true)
            return
        }

        if (!validateData()) {
            toggleErrorRequesting(true, t('digitalVaultUploadView.errors.complete.all.fields'), 3000, false)
            return
        }

        setShowLoadingRequesting(true)

        try {
            const timezone = localStorageService.getLocalStorageItem('timezone')
            const tagNames = tags.map(tag => tag.text)

            let data = new FormData()
            let infoType = infoTypes.find(i => Number(i.id) === Number(uploadData.infoType))
            const infoTypeName = (infoType.id === Number(ENV.REACT_APP_DOCUMENT_INFOTYPE_EXPEDIENTE_ID)) ? ENV.REACT_APP_DIGITAL_VAULT_EXPEDIENTE : ENV.REACT_APP_DIGITAL_VAULT_DOCUMENT

            // Normaliza variables para backend
            const prepareVariablesForBackend = (variables) => {
                return variables
                    .filter(v => !(v.deleted && !v.id))
                    .map(v => {
                        let value = v.valueVariable
                        if (v.typeData === 'date') {
                            if (value instanceof Date) value = value.toISOString()
                            else if (typeof value === 'string') {
                                const d = new Date(value)
                                value = isNaN(d.getTime()) ? '' : d.toISOString()
                            }
                        }
                        if (v.typeData === 'boolean' && v.valueVariable) {
                            value = { checked: v.valueVariable?.checked, true: (v.valueVariable?.true || ''), false: (v.valueVariable?.false || '') }
                        }
                        const obj = {
                            variableName: v.variableName,
                            typeData: v.typeData,
                            valueVariable: (value ?? '')
                        }
                        if (v.id) obj.id = v.id
                        return obj
                    })
                    .filter(v => !!(v.variableName && String(v.variableName).trim()))
            }

            // Datos generales del documento
            data.append('timezone', timezone)
            data.append('infoType', infoTypeName)
            data.append('name', uploadData.name)
            data.append('description', uploadData.description)
            data.append('tags', JSON.stringify(tagNames))
            data.append('confidential', uploadData.confidential)
            data.append('notify', uploadData.notify)

            if (dateStart instanceof Date && !isNaN(dateStart.getTime())) {
                data.append('startDate', dateStart.toISOString())
            } else {
                data.append('startDate', '')
            }

            if (dateEnd instanceof Date && !isNaN(dateEnd.getTime())) {
                data.append('validation', dateEnd.toISOString())
            }

            // Variables personalizadas
            const typeDocVars = Array.isArray(uploadData.typeDocument?.variables) ? uploadData.typeDocument.variables : []
            let resolvedCustomVars = (customVariables || []).map(v => {
                if (!v.id && v.variableName) {
                    const match = typeDocVars.find(tv => String(tv.variableName || tv.name || '').trim().toLowerCase() === String(v.variableName).trim().toLowerCase())
                    if (match && match.id) return { ...v, id: match.id }
                }
                return v
            })

            const isNewTypeDocument = (uploadData?.typeDocument && Number(uploadData.typeDocument.id) === -1)
            const typeDocId = uploadData?.typeDocument?.id
            const missingVars = resolvedCustomVars.filter(v => !v.id && v.variableName)
            if (!isNewTypeDocument && Number.isFinite(Number(typeDocId)) && Number(typeDocId) > 0 && missingVars.length > 0) {
                for (const v of missingVars) {
                    try {
                        await documentsTypeService.createOrUpdateVariable({
                            typeDocumentId: Number(typeDocId),
                            variableName: v.variableName,
                            typeData: v.typeData,
                            formatVariableKey: v.formatVariableKey || null,
                            mandatory: false,
                            token
                        })
                    } catch (_) { /* seguir con las demás */ }
                }
                try {
                    const typesResp = await categoryService.getTypeDocumentsWithVariables(token)
                    if (typesResp && typesResp.statusCode === 200 && Array.isArray(typesResp.data)) {
                        const selectedType = typesResp.data.find(td => Number(td.id) === Number(typeDocId))
                        const nameToId = new Map((selectedType?.variables || []).map(v => [String(v.variableName || v.name || '').trim().toLowerCase(), v.id]))
                        resolvedCustomVars = resolvedCustomVars.map(v => v.id ? v : ({ ...v, id: nameToId.get(String(v.variableName || '').trim().toLowerCase()) || v.id }))
                    }
                } catch (_) { /* noop */ }
            }

            const normalizedVariables = prepareVariablesForBackend(resolvedCustomVars);
            data.append('variables', JSON.stringify(normalizedVariables));

            // Empresa y categoría
            data.append('companyId', uploadData.companyId)
            data.append('categoryId', uploadData.pathBreadcrumb[uploadData.pathBreadcrumb.length - 1])
            const safePath = Array.isArray(uploadData.pathBreadcrumb)
                ? [uploadData.categoryId, ...uploadData.pathBreadcrumb].join('/')
                : uploadData.categoryId
            data.append('pathBreadcrumb', safePath)
            data.append('workflowId', process.env.REACT_APP_ID_NEW_DOCUMENT)

            // Tipo de documento
            if (Number(uploadData.typeDocument.id) === -1) {
                const name = uploadData.typeDocument.name
                const typeDocument = typeDocuments.find(i => i.name.toLowerCase() === name.toLowerCase())
                data.append('newTypeDocumentName', typeDocument ? typeDocument.name : name)
            } else {
                data.append('typeDocumentId', uploadData.typeDocument.id)
            }

            // Archivos
            uploadData.uploadedFiles.forEach((f) => {
                data.append(f.name, f.file)
            })

            // 👇🏽 Si se requiere OCR, validar si ya se hizo
            if (ocrSelected === 'Extraer entidades') {
                const hasEntities = (documentsToOCR && documentsToOCR.length > 0)

                if (!hasEntities) {
                    toggleErrorRequesting(true, t('digitalVaultUploadView.modal.custom.data.error.extractBeforeSave'), 3000, false)
                    setShowLoadingRequesting(false)
                    return
                }
            }

            // 👇🏽 Preparar archivos OCR si aplica
            let dataFilesToOCR = []

            if (ocrSelected === 'Extraer entidades' ||
                ocrSelected === ENV.REACT_APP_OPTIONS_SEND_DOCUMENT_TO_OCR_ALL_DOCUMENTS) {
                (documentsToOCR || []).forEach(doc => {
                    if (doc.value) {
                        dataFilesToOCR.push({
                            fileId: doc.id,
                            fileName: doc.name,
                            process: doc.process,
                            processId: doc.processId,
                            pages: doc.pages
                        })
                    }
                })
            }
            data.append('sendFilesToOCRValue', ocrSelected || ENV.PREFERENCE_PROCESS_DOCUMENT_BUTTON_NO_EXTRACT)
            data.append('dataFilesToOCR', JSON.stringify(dataFilesToOCR))

            // Agregar categoría o Subcategoria
            if (categoryName && strBtn === t('fileManager.toolbar.newCategory')) {
                const newCategory = {
                    name: categoryName,
                    parent: null,
                    type: 'Cat',
                    level: 1,
                    subcategories: []
                };

                data.append('newCategory', JSON.stringify(newCategory))
            }

            // 👇🏽 Llamar al servicio
            const response = await categoryService.saveDocumentDigitalVault(token, data);
            if (response && response.statusCode === 200) {
                setShowLoadingRequesting(false)
                setShowCompletedRequesting(true)

                const createdId = (
                    response?.data?.document?.id ||
                    response?.data?.data?.document?.id ||
                    response?.data?.id ||
                    response?.id ||
                    null
                )

                if (createdId) {
                    setTimeout(() => {
                        setShowCompletedRequesting(false)
                        history.push({
                            pathname: '/digital-vault/home',
                            state: {
                                ...(fileManagerState || {}),
                                documentId: createdId
                            }
                        })
                    }, 1200)
                    return
                }
                setTimeout(() => {
                    setShowCompletedRequesting(false)
                    history.push('/digital-vault/home')
                }, 4000)
                return
            } if (response && response.statusCode === 450) {
                setShowLoadingRequesting(false)
                toggleErrorRequesting(true, t('digitalVaultUploadView.errors.document.not.assign.category'), 4000, false)
            } else {
                setShowLoadingRequesting(false)
                toggleErrorRequesting(true, response.message || t('digitalVaultUploadView.errors.general.save'), 4000, false)
            }
        } catch (e) {
            setShowLoadingRequesting(false)
            toggleErrorRequesting(true, e.message, 4000, false)
        }
    }

    const saveExtractedEntities = () => {
        setUploadData(prev => ({
            ...prev,
            documentsToOCR: documentsToOCR
        }))

        setEntitiesExtracted(true)

        setMessageDialog(t('digitalVaultUploadView.modal.entities.success.saved'))
        setShowCompletedRequesting(true)
        setTimeout(() => {
            setShowCompletedRequesting(false)
            setMessageDialog('')
        }, 3000)

        closeModalSendToOcr()
    }

    useEffect(() => {
        const localStorageService = new LocalStorageService()
        const user = localStorageService.getLocalStorageItem('user')

        loadCompanies()
        getTypeDocumentsWithVariables()

            ; (async () => {
                try {
                    const resp = await templateService.getFormatVariables(token)
                    if (Array.isArray(resp)) setFormatVariables(resp)
                } catch (e) {
                    console.log(e)
                }
            })()
    }, [])

    useEffect(() => {
        if (!documentData || !documentData.id) return
        let url = (documentData && documentData.files && documentData.files.length > 0 && documentData.files[0].url) ? documentData.files[0].url : ''
        let fileType = (documentData && documentData.files && documentData.files.length > 0 && documentData.files[0].fileType) && documentData.files[0].fileType
        let name = (documentData && documentData.name) ? documentData.name : ''
        let newData = {
            infoType: (documentData.infoType === 'Expediente') ? 2 : 1,
            name: name,
            companyId: null,
            categoryId: null,
            pathBreadcrumb: [],
            typeDocument: null,
            uploadedFiles: documentData.infoType === 'Expediente' ? documentData.files : [],
        }

        //GET document info and pages
        getDocumentPages()
        setFileType(fileType)
        setUrlPdf(url)
        setBlobAWS(url)
        setShowUploadBtn(false)
        setUploadData(newData)
        setShowBtnCancel(true)
    }, [documentData])

    useEffect(() => {
        if (!documentData || !documentData.id || !documentData.companyId || !companies || companies.length === 0) return
        let pathBreadcrumb = []
        if (documentData.pathBreadcrumb) {
            let pathBreadcrumbSplit = documentData.pathBreadcrumb.split('/')
            pathBreadcrumbSplit.map(subCatId => pathBreadcrumb.push(Number(subCatId)))
        }

        setUploadData(prev => {
            return {
                ...prev,
                companyId: documentData.companyId,
                categoryId: documentData.categoryParent || null,
                pathBreadcrumb: pathBreadcrumb
            }
        })
    }, [companies, documentData])

    useEffect(() => {
        if (!documentData || !documentData.id || !documentData.typeDocumentId || !typeDocuments || typeDocuments.length === 0) return
        let typeDocument = typeDocuments.find(typeDoc => typeDoc.id === documentData.typeDocumentId)
        setUploadData(prev => {
            return {
                ...prev,
                typeDocument: typeDocument || null
            }
        })
    }, [typeDocuments, documentData])

    useEffect(() => {
        if (allTypeDocuments.length === 0 || !documentData) return
        const infoType = documentData.infoType || ENV.REACT_APP_DIGITAL_VAULT_DOCUMENT
        const typeDocumentsFiltered = allTypeDocuments.filter(td => { return td.infoType === infoType })
        setTypeDocuments(typeDocumentsFiltered)
    }, [documentData, allTypeDocuments])

    const handleUpdateDocument = async (searcPreference, ocrSelected) => {
        const isSpanish = (language || 'es').toLowerCase().startsWith('es')
        const noun = Number(uploadData.infoType) === 2
            ? t('digitalVaultUpload.noun.file', { defaultValue: isSpanish ? 'expediente' : 'file' })
            : t('digitalVaultUpload.noun.document', { defaultValue: isSpanish ? 'documento' : 'document' })

        if (!uploadData.companyId || Number(uploadData.companyId) === 0) {
            const msgPrefix = t('digitalVaultUpload.error.select.company', {
                defaultValue: isSpanish
                    ? 'Debes de seleccionar una empresa antes de cargar un'
                    : 'You must select a company before uploading a'
            })
            setCategoryWarningMessage(`${msgPrefix} ${noun}.`)
            setShowCategoryWarningModal(true)
            return
        }

        const hasValidSubcategory = isSubcategorySelected()
        if (!hasValidSubcategory) {
            setCategoryWarningMessage('')
            setShowCategoryWarningModal(true)
            return
        }

        if (!validateUpdateData()) {
            toggleErrorRequesting(true, t('digitalVaultUploadView.errors.complete.all.fields'), 3000, false)
            return
        }
        setShowLoadingRequesting(true)
        let name = uploadData.name
        let alias = documentData.alias
        let description = uploadData.description
        let startDate = documentData.startDate
        let validation = dateEnd
        let amount = documentData.amount
        let confidential = uploadData.confidential
        let notify = uploadData.notify
        let mandatory = uploadData.mandatory
        let penalty = uploadData.penalty
        let tags = uploadData.tags
        let variables = customVariables
        let entities = { values: [] }
        let companyId = uploadData.companyId
        let categoryId = uploadData.pathBreadcrumb[uploadData.pathBreadcrumb.length - 1]
        let pathBreadcrumb = [uploadData.categoryId, ...uploadData.pathBreadcrumb].join('/')
        if (typeof pathBreadcrumb !== 'string') {
            pathBreadcrumb = String(pathBreadcrumb || '')
        }
        let workflowEXP = documentData.infoType === 'Expediente' ? true : null
        let typeDocument = {
            typeDocumentId: (uploadData && uploadData.typeDocument.id && uploadData.typeDocument.id > 0) ? uploadData.typeDocument.id : null,
            newTypeDocument: (uploadData && uploadData.typeDocument && uploadData.typeDocument.name && (!uploadData.typeDocument.id || uploadData.typeDocument.id < 0)) ? uploadData.typeDocument : null
        }

        if (searcPreference) {
            let showModalOCR = true
            let userPreferences = await preferenceService.getClientPreferences(token, timezone)
            let sendDocsToOcrPreference = userPreferences.data.find(preference => preference.preferenceName === process.env.REACT_APP_PREFERENCE_DOCUMENT_TO_OCR)
            if (sendDocsToOcrPreference) {
                let preferenceOCR = (!sendDocsToOcrPreference.stringValue || (sendDocsToOcrPreference.stringValue && sendDocsToOcrPreference.stringValue === ENV.REACT_APP_OPTIONS_SEND_DOCUMENT_TO_OCR_USER_SELECT)) ? true : false
                if (!preferenceOCR) showModalOCR = false
            }
        }

        let dataFilesToOCR = []
        let sendFilesToOCRValue = ocrSelected
        let sendFilesToOCR = (ocrSelected === 'Extraer entidades' || ocrSelected === ENV.REACT_APP_OPTIONS_SEND_DOCUMENT_TO_OCR_ALL_DOCUMENTS) ? true : false
        if (sendFilesToOCR) {
            documentsToOCR.map((doc) => {
                if (doc.value) {
                    let docSend = {
                        fileId: doc.id,
                        fileName: doc.name,
                        process: doc.process,
                        processId: doc.processId,
                        pages: doc.pages
                    }
                    dataFilesToOCR.push(docSend)
                }
                return doc
            })
        }
        setShowLoadingRequesting(false)
        handleSaveData(alias, description, startDate, validation, amount, confidential, notify, mandatory, penalty, tags, entities, variables, name, categoryId, companyId, pathBreadcrumb, workflowEXP, null, typeDocument, sendFilesToOCR, dataFilesToOCR, sendFilesToOCRValue)
    }

    const handleWathchExp = (doc) => {
        switch (doc.fileType) {
            case null:
                setFileType('pdf')
                break
            default:
                setFileType(doc.fileType)
                setUrlPdf(doc.url)
                return
        }
        /** @type {string} */
        let url = (doc.url) ? doc.url : ''
        setUrlPdf(url)
    }

    const rejectUploadDocument = async () => {
        setShowLoadingRequesting(true)
        let errorMessage = t('digitalVaultUploadView.errors.general.reject')
        try {
            let documentRejected = await digitalVaultDocumentService.rejectDocument(documentId, token)
            if (documentRejected && documentRejected.data && Number(documentRejected.statusCode) === 200) {
                setShowLoadingRequesting(false)
                setShowCompletedRequesting(true)
                setTimeout(() => {
                    setShowCompletedRequesting(false)
                    history.push('/')
                }, 4000)
            } else {
                setShowLoadingRequesting(false)
                toggleErrorRequesting(true, errorMessage, 4000, false)
            }
        } catch (error) {
            setShowLoadingRequesting(false)
            toggleErrorRequesting(true, errorMessage, 4000, false)
        }
    }

    const getDocumentPages = async () => {
        let errorMessage = t('digitalVaultUploadView.errors.general.document')
        try {
            let document = await digitalVaultDocumentService.getDocumentPages(documentId, token)
            if (document && document.data && Number(document.statusCode) === 200) {
                let docsCreditsOCR = setCreditsToDocuments(document.data.files, t)
                let docsToOCR = (docsCreditsOCR && docsCreditsOCR.documentsToOCR) ? docsCreditsOCR.documentsToOCR : []
                let totalCredits = (docsCreditsOCR && docsCreditsOCR.totalCredits) ? docsCreditsOCR.totalCredits : 0

                setTotalCredits(totalCredits)
                setDocumentsToOCR(docsToOCR)
            } else {
                toggleErrorRequesting(true, errorMessage, 4000, false)
            }
        } catch (error) {
            toggleErrorRequesting(true, errorMessage, 4000, false)

        }
    }

    const closeModalSendToOcr = () => {
        setShowDialogSendDocToOcr(false)
    }

    const handleCheckBoxDoc = (e, dataItem) => {
        let copyDocs = [...documentsToOCR]
        let valueCheck = e.target.checked
        let totalCredits = 0
        copyDocs = copyDocs.map((doc) => {
            if (doc.id === dataItem.id) {
                doc.value = valueCheck
            }

            if (doc.value) {
                totalCredits = totalCredits + doc.credits
            }
            return doc
        })

        setDocumentsToOCR(copyDocs)
        setTotalCredits(totalCredits)
    }


    useEffect(() => {
        if (documentData?.variables?.length) {
            const normalized = documentData.variables.map(v => ({ ...v, deleted: false }))
            setCustomVariables(normalized)
        } else if (uploadData?.typeDocument?.variables) {
            const normalized = uploadData.typeDocument.variables.map(v => ({ ...v, deleted: false }))
            setCustomVariables(normalized)
        }
    }, [documentData, uploadData?.typeDocument])

    useEffect(() => {
    }, [customVariables])

    useEffect(() => {
        if (allTypeDocuments.length === 0 || !documentData) return
        const infoType = documentData.infoType || ENV.REACT_APP_DIGITAL_VAULT_DOCUMENT
        const typeDocumentsFiltered = allTypeDocuments.filter(td => { return td.infoType === infoType })
        setTypeDocuments(typeDocumentsFiltered)
    }, [documentData, allTypeDocuments])

    const getTypeDocumentsWithVariables = async () => {
        const response = await categoryService.getTypeDocumentsWithVariables(token)
        if (response.statusCode === 200 && response.data) {
            let typeDocumentOptions = response.data
            typeDocumentOptions.sort((a, b) =>
                a.name.toLowerCase().localeCompare(b.name.toLowerCase())
            )

            // Filter only "Documento" infoType
            const onlyTypeDocument = typeDocumentOptions.filter(td => { return td.infoType === ENV.REACT_APP_DIGITAL_VAULT_DOCUMENT })
            setTypeDocuments(onlyTypeDocument)
            setAllTypeDocuments(typeDocumentOptions)
        } else {
            throw new Error(response.message || t('digitalVaultUploadView.errors.type.documents.default'))
        }
    }



    return (
        <DigitalVaultUploadView
            {...props}
            setFileType={setFileType}
            fileType={fileType}
            infoTypes={infoTypes}
            companies={companies}
            categories={categories}
            subcategoryTree={subcategoryTree}
            allTypeDocuments={allTypeDocuments}
            typeDocuments={typeDocuments}
            setTypeDocuments={setTypeDocuments}
            handleFile={handleFiles}
            deleteFile={deleteFile}
            uploadData={uploadData}
            handleUploadDataChange={handleUploadDataChange}

            // Categorias y subcategorias
            handleSubmitCategoryOrSubcategory={handleSubmitCategoryOrSubcategory}
            handleCreateCategoryOrSubcategory={handleCreateCategoryOrSubcategory}
            toggleCategoryWarningModal={setShowCategoryWarningModal}
            setShowCategoryInputDialog={setShowCategoryInputDialog}
            handleCreateNewCategory={handleCreateNewCategory}
            handleTreeNodeClick={handleTreeNodeClick}
            createNewCategory={createNewCategory}
            openSubcategories={openSubcategories}
            setCategoryName={setCategoryName}
            openCategories={openCategories}

            showCategoryWarningModal={showCategoryWarningModal}
            showCategoryInputDialog={showCategoryInputDialog}
            categoryNameError={categoryNameError}
            categoriesData={categoriesData}
            categoryName={categoryName}
            strBtn={strBtn}
            categoryWarningMessage={categoryWarningMessage}

            //Tags
            handleDeleteChipTag={handleDeleteChipTag}
            onBlurInputTag={onBlurInputTag}
            handleInputTag={handleInputTag}

            inputTag={inputTag}
            tags={tags}


            //Checkboxes
            handleChangeCheckConfidential={handleChangeCheckConfidential}
            handleChangeCheckNotify={handleChangeCheckNotify}

            confidential={confidential}
            notify={notify}

            //Fechas 
            onChangeDatepickerDateEnd={onChangeDatepickerDateEnd}
            onChangeDatepicker={onChangeDatepicker}

            limitDateDue={limitDateDue}
            formatCeleb={formatCeleb}
            dateStart={dateStart}
            formatVen={formatVen}
            dateEnd={dateEnd}

            //Variables
            getTypeDocumentsWithVariables={getTypeDocumentsWithVariables}
            closeModalVariable={closeModalVariable}
            setCustomVariables={setCustomVariables}
            handleSaveVariable={handleSaveVariable}
            openModalVariable={openModalVariable}
            setValueVariable={setValueVariable}
            setVariableName={setVariableName}
            deleteVariable={deleteVariable}
            setTypeData={setTypeData}

            customVariables={customVariables}
            valueVariable={valueVariable}
            variableName={variableName}
            showModal={showModal}
            typeData={typeData}

            //Entidades
            setShowEntitiesSuccessModal={setShowEntitiesSuccessModal}
            setShowDialogSendDocToOcr={setShowDialogSendDocToOcr}
            openModalExtractEntities={openModalExtractEntities}
            saveExtractedEntities={saveExtractedEntities}
            setInvalidFields={setInvalidFields}
            onCancel={onCancel}
            onSave={onSave}

            showEntitiesSuccessModal={showEntitiesSuccessModal}
            entitiesExtracted={entitiesExtracted}
            messageDialog={messageDialog}
            invalidFields={invalidFields}
            ENV={ENV}

            // Modal de variables (formatos)
            formatVariables={formatVariables}

            isLoading={isLoading}
            toggleLoadingScreen={setIsLoading}
            showLoadingRequesting={showLoadingRequesting}
            toggleLoadingRequesting={setShowLoadingRequesting}
            showErrorRequesting={showErrorRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            messageError={messageError}
            showCompletedRequesting={showCompletedRequesting}
            toggleCompletedRequesting={setShowCompletedRequesting}

            documentId={documentId}
            handleUpdateDocument={(noWorkflow) ? handleSubmitNoWorkflow : handleUpdateDocument}
            handleWathchExp={handleWathchExp}
            documentData={documentData}
            urlPdf={urlPdf}
            blobAWS={blobAWS}

            showUploadBtn={showUploadBtn}

            showBtnCancel={showBtnCancel}
            rejectUploadDocument={rejectUploadDocument}

            showDialogSendDocToOcr={showDialogSendDocToOcr}
            closeModalSendToOcr={closeModalSendToOcr}

            documentsToOCR={documentsToOCR}
            handleCheckBoxDoc={handleCheckBoxDoc}
            totalCredits={totalCredits}
        />
    )
}

export default withRouter(withTranslation()(DigitalVaultUploadAction))